import {
  Component,
  input,
  InputSignal,
  InputSignalWithTransform,
  numberAttribute
} from '@angular/core';

@Component({
  selector: 'td-wb-symbol-logo-overflow',
  templateUrl: 'symbol-logo-overflow.component.html',
  styleUrls: ['symbol-logo-overflow.component.scss'],
  host: {
    '[style.--td-wb-overflow-logo-size]': 'this.getSize()',
    '[attr.aria-hidden]': 'true'
  }
})
export class SymbolLogoOverflowComponent {
  private static readonly DEFAULT_SIZE: number = 30;
  private static readonly EXTRA_SMALL_SIZE_THRESHOLD: number = 25;
  private static readonly LARGE_SIZE_THRESHOLD: number = 40;
  private static readonly EXTRA_LARGE_SIZE_THRESHOLD: number = 70;
  size: InputSignalWithTransform<number, unknown> =  input<number, unknown>(SymbolLogoOverflowComponent.DEFAULT_SIZE, { transform: numberAttribute });
  displayNumber: InputSignal<number> = input<number>();

  getSize(): string {
    return isNaN(Number(this.size())) ? SymbolLogoOverflowComponent.DEFAULT_SIZE + 'px' : this.size() + 'px';
  }

  isExtraLarge(): boolean {
    return this.size() >= SymbolLogoOverflowComponent.EXTRA_LARGE_SIZE_THRESHOLD;
  }

  isSmall(): boolean {
    return this.size() > SymbolLogoOverflowComponent.EXTRA_SMALL_SIZE_THRESHOLD && this.size() < SymbolLogoOverflowComponent.LARGE_SIZE_THRESHOLD;
  }

  isExtraSmall(): boolean {
    return this.size() <= SymbolLogoOverflowComponent.EXTRA_SMALL_SIZE_THRESHOLD;
  }
}
